import React from 'react';
import PortalPaginationControls from '../../layout/PortalPaginationControls';

const PaginationButtons = ({ page, pageCount, handleChangePage }) => (
  <PortalPaginationControls
    currentPage={page + 1}
    totalPages={pageCount}
    onPageChange={(nextPage) => handleChangePage(nextPage - 1)}
    sx={{ mt: 2 }}
  />
);

export default PaginationButtons;
